import aInstance from 'services/api'
import Geodata from 'model/geodata'

export const getGeodata = async (query: string): Promise<Geodata[]> => {
  const url = '/geo-data/find'
  const res = await aInstance.get(url, { params: { query } })
  return res?.data?.items || []
}
